import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "siem-workspace-mode"
const DEFAULT_MODE = "analyst"

export default class extends Controller {
  static targets = ["analystPanel", "workshopPanel", "intelPanel", "huntPanel", "vizPanel", "modeBtn"]

  #boundSwitchMode = null
  #boundChartInject = null
  #boundChartDestroy = null
  #boundChartClear = null
  #boundTreeInject = null
  #boundTreeDestroy = null
  #boundTreeClear = null

  connect() {
    const saved = localStorage.getItem(STORAGE_KEY) || DEFAULT_MODE
    this.setMode(saved)
    this.#boundSwitchMode = (e) => this.setMode(e.detail.mode)
    this.#boundChartInject = (e) => this.#handleVizInject(e, ".siem-viz-chart-output", (wrap) => {
      wrap.querySelector(".siem-render-close")?.addEventListener("click", () => {
        window.dispatchEvent(new CustomEvent("siem:viz-chart-destroy"))
      })
    })
    this.#boundChartDestroy = () => this.#handleVizClear(".siem-viz-chart-output", ".siem-render-output")
    this.#boundChartClear = () => this.vizPanelTarget?.querySelector(".siem-viz-chart-output .siem-render-output")?.remove()
    this.#boundTreeInject = (e) => this.#handleVizInject(e, ".siem-viz-tree-output", (wrap) => {
      const treeOutput = this.vizPanelTarget?.querySelector(".siem-viz-tree-output")
      wrap.querySelector(".siem-proc-tree-close")?.addEventListener("click", () => {
        wrap.remove()
        treeOutput?.querySelector("[data-empty-state]")?.classList.remove("hidden")
      })
    })
    this.#boundTreeDestroy = () => this.#handleVizClear(".siem-viz-tree-output", ".siem-proc-tree-output")
    this.#boundTreeClear = () => this.vizPanelTarget?.querySelector(".siem-viz-tree-output .siem-proc-tree-output")?.remove()
    window.addEventListener("siem:switch-mode", this.#boundSwitchMode)
    window.addEventListener("siem:viz-chart-inject", this.#boundChartInject)
    window.addEventListener("siem:viz-chart-destroy", this.#boundChartDestroy)
    window.addEventListener("siem:viz-chart-clear", this.#boundChartClear)
    window.addEventListener("siem:viz-tree-inject", this.#boundTreeInject)
    window.addEventListener("siem:viz-tree-destroy", this.#boundTreeDestroy)
    window.addEventListener("siem:viz-tree-clear", this.#boundTreeClear)
  }

  disconnect() {
    window.removeEventListener("siem:switch-mode", this.#boundSwitchMode)
    window.removeEventListener("siem:viz-chart-inject", this.#boundChartInject)
    window.removeEventListener("siem:viz-chart-destroy", this.#boundChartDestroy)
    window.removeEventListener("siem:viz-chart-clear", this.#boundChartClear)
    window.removeEventListener("siem:viz-tree-inject", this.#boundTreeInject)
    window.removeEventListener("siem:viz-tree-destroy", this.#boundTreeDestroy)
    window.removeEventListener("siem:viz-tree-clear", this.#boundTreeClear)
  }

  switchMode(event) {
    const mode = event.currentTarget.dataset.mode
    this.setMode(mode)
    localStorage.setItem(STORAGE_KEY, mode)
  }

  #handleVizInject(event, containerSelector, setupClose) {
    if (!this.hasVizPanelTarget) return
    const container = this.vizPanelTarget.querySelector(containerSelector)
    if (!container) return
    event.preventDefault()
    const { wrap } = event.detail
    setupClose(wrap)
    container.querySelector("[data-empty-state]")?.classList.add("hidden")
    container.appendChild(wrap)
    this.setMode("viz")
    localStorage.setItem(STORAGE_KEY, "viz")
  }

  #handleVizClear(containerSelector, outputSelector) {
    if (!this.hasVizPanelTarget) return
    const container = this.vizPanelTarget.querySelector(containerSelector)
    if (!container) return
    container.querySelector(outputSelector)?.remove()
    container.querySelector("[data-empty-state]")?.classList.remove("hidden")
  }

  setMode(mode) {
    this.element.dataset.siemMode = mode

    this.modeBtnTargets.forEach(btn => {
      btn.classList.toggle("active", btn.dataset.mode === mode)
    })

    this.analystPanelTargets.forEach(el => el.classList.toggle("hidden", mode !== "analyst"))

    if (this.hasWorkshopPanelTarget) {
      this.workshopPanelTarget.classList.toggle("hidden", mode !== "workshop")
    }
    if (this.hasIntelPanelTarget) {
      this.intelPanelTarget.classList.toggle("hidden", mode !== "intel")
    }
    if (this.hasHuntPanelTarget) {
      this.huntPanelTarget.classList.toggle("hidden", mode !== "hunt")
    }
    if (this.hasVizPanelTarget) {
      this.vizPanelTarget.classList.toggle("hidden", mode !== "viz")
    }
  }
}
